module.exports = __webpack_public_path__ + "static/yt_1@2x-b9502dd85dded5901d0dbe241a3d4708.jpg";